import axios from "axios";

const _axios = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_API,
  timeout: 10000,
  withCredentials: true
});

// 全局拦截处理
/* _axios.interceptors.response.use(
  response => {
    // 接口返回未登录且当前不在登录页时，强制跳转到登录页
    if (response.data.code === '100005' && window.app.$route.name !== 'Account') {
      window.app.$router.push({
        name: 'Account',
        query: {
          redirect: window.app.$route.fullPath
        }
      })
    } else {
      return response
    }
  }
) */

export const http = (url, data, method = "post") => {
  return new Promise(function(resolve, reject) {
    let d = {
      url,
      method
    };
    if (method.toLowerCase() === "get") {
      d.params = data;
    } else {
      d.data = data;
    }
    if (data instanceof FormData) {
      d.headers = {
        "Content-Type": "multipart/form-data"
      };
    }
    _axios(d)
      .then(response => {
        response && resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};
